import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_notifications = _resolveComponent("vue-notifications")!
  const _component_vue_pm = _resolveComponent("vue-pm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_vue_notifications),
    _createVNode(_component_vue_pm)
  ], 64 /* STABLE_FRAGMENT */))
}